var map = require('../array/virtual/map');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.map;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.map) ? map : own;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/instance/map.js
// module id = 989
// module chunks = 0